import Joi from 'joi';
import _ from 'underscore';

import {
	api as apiRequest,
	batchApi as batchApiRequest
} from '@culture/common-helpers/request';
import { instituteRedirect } from '@culture/common-helpers/redirect';

import {
	addCleanCache,
	parsePathParams,
	preparePathParams,
	getBreadcrumbsParams
} from '@culture/common-helpers/params';

import { movieTypesHash } from '@culture/utils/helpers/movies';
import { statusesHash } from '@culture/utils/helpers/statuses';
import { getBreadcrumbs, getRubrics } from 'logic/page';
import Template from 'pageTemplates/nationalStreaming/archive';

const ArchivePage = (props) => <Template {...props} />;

const validationSchema = Joi.object().keys({
	pathParams: Joi.array().items(Joi.string()),
	cleanCache: Joi.boolean(),
	page: Joi.number().default(1),
	limit: Joi.number().default(24),
	sort: Joi.string().default('-views'),
	query: Joi.string()
});

const pathParamsValidationSchema = Joi.object().keys({
	institute: Joi.string(),
	year: Joi.number(),
	type: Joi.string().valid(..._(movieTypesHash).keys())
});

const getMovies = (params, pathParams) => {
	let movieParams = addCleanCache(
		{
			fields: [
				'title',
				'thumbnailFile',
				'additionalThumbnailFile',
				'type',
				'institute',
				'name',
				'toDate',
				'publishDate',
				'rubrics'
			].join(),
			cached: true,
			statuses: [statusesHash.published],
			bidType: 'nationalProject',
			isPassed: true,
			withVideo: true,
			..._(params).omit('cleanCache', 'pathParams')
		},
		params.cleanCache
	);

	movieParams = preparePathParams(movieParams, pathParams);

	return apiRequest('movies', movieParams);
};

export async function getServerSideProps({ query, resolvedUrl, res }) {
	const params = Joi.attempt(query, validationSchema, {
		stripUnknown: true
	});

	const parsedPathParams = parsePathParams(params.pathParams);

	const pathParams = Joi.attempt(
		parsedPathParams.params,
		pathParamsValidationSchema
	);

	const { url, status } = await instituteRedirect(
		resolvedUrl,
		pathParams.institute
	);

	if (url) {
		res.redirect(status, url);
		return {};
	}

	const rubricPath = 'live/national-streaming/archive';

	const [rubrics, breadcrumbs, movies] = await batchApiRequest([
		getRubrics(rubricPath),
		getBreadcrumbs(getBreadcrumbsParams(rubricPath, params)),
		getMovies(params, pathParams)
	]);

	return {
		props: {
			breadcrumbs,
			movies: movies.items,
			total: movies.total,
			limit: params.limit,
			rubricPath,
			urlParams: {
				...pathParams,
				..._(params).omit('pathParams', 'limit')
			},
			rubric: rubrics.items.length ? rubrics.items[0] : null
		}
	};
}

export default ArchivePage;
